export enum DateFormatKinds {
  ymdStringAd,
  ymdStringJcEra,
  ymdStringJc,
  ymdSlashAd,
  ymdSlashJcE,
  ymdDotAd,
  ymdDotJcE,
  ymStringAd,
  ymStringJcEra,
  ymStringJc,
  ymDotJcE,
  mdStringAd,
  mdSlashAd,
  jcEra,
  jcE,
}
